import { Box, Tooltip } from "@mui/joy";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';

const availableHelp:any = {
    // businesses
    not_in_district: 'Businesses Not in District are excluded from reporting', //'Include in Reporting',
    moved_in_date: 'Date business moved into district',
    moved_out_date: 'Date business moved out of district',

    // properties
    commercial_units: 'This does not include any property units listed below',
    residential_units: 'This does not include any property units listed below',
    latitude: {
        text: 'Need help finding coordinates?',
        link: 'https://www.latlong.net/',
    },
    longitude: {
        text: 'Need help finding coordinates?',
        link: 'https://www.latlong.net/',
    },

    // opportunities
    opportunity_link: 'This is a public link that volunteers use to sign up',

    deleted_user: 'This user does not have a contact. Please contact support.',
};

function helpText(slug:string) {
    return availableHelp[slug] ?? null;//'N/A';
}

export function ContextualHelp(
    { slug, children }
    :
    { slug: string, children?: any }
) {
    const getHelpText = helpText(slug);

    if(!getHelpText) {
        console.log('missing help text', slug);
    }

    const hasLink = typeof getHelpText === 'object' && !!getHelpText?.link;
    const thehelpText = typeof getHelpText === 'object' ? getHelpText.text : getHelpText;

    return (
        <Tooltip title={thehelpText} placement="top-end">
            <Box>
                {children}
                {hasLink === false && (
                    <HelpOutlineRoundedIcon sx={{fontWeight: 'lighter', ml: '1px'}} />
                )}
                {hasLink !== false && (
                    <a href={getHelpText?.link} target="_blank">
                        <HelpOutlineRoundedIcon sx={{fontWeight: 'lighter', ml: '1px'}} />
                    </a>
                )}
            </Box>
        </Tooltip>
    );
}
